export const showLoading = () => {
	const loading = document.getElementById("loading")
	loading.classList.remove("hidden")
}

export const hideLoading = () => {
	const loading = document.getElementById("loading")
	loading.classList.add("hidden")
}
